import TradeTxView from 'src/sections/overview/__trade-tx/view/trade-tx-view';

export default function TradeTx() {
  return <TradeTxView />;
}
